import { styled } from '@mui/material';

type BasicCardContentProps = {
  children: React.ReactNode;
};

export const BasicCardContent = ({ children }: BasicCardContentProps) => {
  return <CardContent>{children}</CardContent>;
};

const CardContent = styled('div')(() => ({
  padding: '1rem',
}));
